export default () => ({
  // jobs: null,
  error: '',
});
